import * as React from 'react';
import { Icon as MuiIcon, IconProps as MuiIconProps } from '@mui/material';

import { BaseComponentProps } from './types';

export interface IconProps
  extends BaseComponentProps,
    Pick<MuiIconProps, 'children' | 'color' | 'fontSize'> {
  iconFamily?: 'material';
  rotate?: '90' | '180' | '-90';
}

export interface IconChildComponentProps {
  icon?: string | React.ReactElement<MuiIconProps>;
  iconProps?: Omit<IconProps, 'children'>;
}

export const Icon = ({
  children,
  iconFamily = 'material',
  rotate,
  ...otherProps
}: IconProps) => {
  const fullProps = rotate
    ? { ...otherProps, style: { transform: `rotate(${rotate}deg)` } }
    : otherProps;
  /*
    The goal here is to allow someone to either pass an 
    a specific MUI Icon component such as <AddIcon /> or
    to pass the string name (e.g. 'add') and have it render.

    Primarily, we use the string names for icons today but,
    based on Mui's recomendation, should start to move towards
    using the SVG icon components directly
  */
  if (typeof children === 'string') {
    if (iconFamily === 'material') {
      return <MuiIcon {...fullProps}>{children}</MuiIcon>;
    }
    return null;
  }
  return React.cloneElement(
    children as React.ReactElement,
    {
      ...fullProps,
    } as React.Attributes,
  );
};
